import { ElementRef, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import { find, isNull, isUndefined } from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime, filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcOutlinedSelectComponent = /** @class */ (function () {
    function FcOutlinedSelectComponent(elementRef, fuseTranslationLoaderService, apollo) {
        this.elementRef = elementRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.alreadySelected = [];
        this.predefinedOptions = [];
        this.select = new EventEmitter();
        this.searchTerm = '';
        this.reachedBottom = false;
        this.hasMoreOptions = true;
        this.optionsOffset = 0;
        this.optionsLimit = 10;
        this.removeSubscriptions = new Subject();
        this.showOptions = false;
        this.selectedValue = null;
        this.isOptionsAbove = false;
        this.isLoading = false;
        this.textInputForm = new FormControl(null);
        this.options = [];
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcOutlinedSelectComponent.prototype.onClickOutside = function (event) {
        var clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside) {
            this.showOptions = false;
        }
    };
    FcOutlinedSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setSelectedValue();
        if (this.predefinedOptions.length) {
            this.options = this.predefinedOptions;
            return;
        }
        this.searchFn(this.searchTerm, this.optionsLimit, this.optionsOffset)
            .subscribe(function (options) {
            _this.options = _this.mapQueryResultToOutlinedSelectOption(options);
        });
        this.textInputForm.valueChanges
            .pipe(takeUntil(this.removeSubscriptions), debounceTime(500), tap(function () { return _this.resetValues(); }), map(function (value) { return value || ''; }), filter(function (value) { return typeof value === 'string'; }), map(function (value) { return value.trim(); }), tap(function (searchTerm) {
            _this.searchTerm = searchTerm;
            _this.isLoading = true;
        }), switchMap(function () { return _this.searchFn(_this.searchTerm, _this.optionsLimit, _this.optionsOffset); }), tap(function () { return _this.isLoading = false; })).subscribe(function (options) {
            _this.options = _this.mapQueryResultToOutlinedSelectOption(options);
        });
        this.control.valueChanges.subscribe(function () {
            _this.setSelectedValue();
        });
    };
    FcOutlinedSelectComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    FcOutlinedSelectComponent.prototype.selectOption = function (option) {
        if (!this.alreadySelected.includes(option.text)) {
            this.control.setValue(option.value);
            this.setSelectedValue();
        }
        else {
            this.control.setValue(null);
            this.setSelectedValue();
        }
        this.showOptions = false;
    };
    FcOutlinedSelectComponent.prototype.setSelectedValue = function () {
        var value = this.control.value;
        if (isNull(value) || isUndefined(value)) {
            this.selectedValue = null;
            return;
        }
        if (!value.id) {
            var existingValue = find(this.predefinedOptions, {
                value: value.id ? { id: value.id } : value
            });
            this.selectedValue = (existingValue && existingValue.text) || null;
            this.select.emit();
            return;
        }
        this.selectedValue = value.name;
        this.select.emit();
    };
    FcOutlinedSelectComponent.prototype.onBlur = function () {
        this.textInputForm.setValue('');
    };
    FcOutlinedSelectComponent.prototype.clearTextAndSelection = function () {
        this.control.setValue(null);
        this.textInputForm.setValue(null);
    };
    FcOutlinedSelectComponent.prototype.openOptionsList = function () {
        if (this.control.disabled) {
            return;
        }
        var maxOptions = this.options.length < 7 ? this.options.length : 7;
        var optionsListHeight = 48 * maxOptions + 16;
        var componentRect = this.elementRef.nativeElement.getBoundingClientRect();
        var windowHeight = window.innerHeight;
        var spaceAbove = componentRect.top;
        var spaceBelow = windowHeight - componentRect.bottom;
        this.isOptionsAbove = spaceBelow < optionsListHeight || spaceBelow < spaceAbove;
        this.showOptions = true;
    };
    FcOutlinedSelectComponent.prototype.handleScroll = function (event) {
        var ulElement = event.target;
        var maxScrollTop = ulElement.scrollHeight - ulElement.clientHeight;
        if (ulElement.scrollTop >= maxScrollTop - 10 && !this.reachedBottom) {
            this.loadMoreOptions();
            this.reachedBottom = true;
        }
        if (ulElement.scrollTop < maxScrollTop - 10) {
            this.reachedBottom = false;
        }
    };
    FcOutlinedSelectComponent.prototype.mapQueryResultToOutlinedSelectOption = function (data) {
        return data.map(function (item) { return ({
            text: item.name,
            value: item
        }); });
    };
    FcOutlinedSelectComponent.prototype.loadMoreOptions = function () {
        var _this = this;
        try {
            if (!this.hasMoreOptions || this.options.length < 10) {
                return;
            }
            this.optionsOffset += 10;
            this.searchFn(this.searchTerm, this.optionsLimit, this.optionsOffset)
                .pipe(takeUntil(this.removeSubscriptions))
                .subscribe(function (newOptions) {
                if (newOptions.length < 10) {
                    _this.hasMoreOptions = false;
                }
                var optionsToBeAdded = _this.mapQueryResultToOutlinedSelectOption(newOptions);
                _this.options = _this.options.concat(optionsToBeAdded);
            });
        }
        catch (err) {
            sentry.captureException(err);
        }
    };
    FcOutlinedSelectComponent.prototype.resetValues = function () {
        this.optionsOffset = 0;
        this.hasMoreOptions = true;
    };
    return FcOutlinedSelectComponent;
}());
export { FcOutlinedSelectComponent };
